module.exports = __webpack_public_path__ + "img/Img5_204711_BgFg-2-876.524bea51.jpg";